import { CustomerAddressAvenue, CustomerAddressCity } from "@/types/customer/address.type";
import axios from "@/providers/requests";
import ENDPOINTS from "@/providers/end-points";
import { Response } from "@/interface/response.interface";
import Area from "@/modules/delivery-areas/area";
import { AreaType } from "@/types/delivery-areas";
import { AreaInterface } from "@/interface/delivery-areas";

const state = {
  cites: [],
  areas: [],
  isFetchingList: false,
};

const Addresses = {
  namespaced: true,
  state,

  getters: {
    isFetchingList: (state: any): Boolean => state.isFetchingList,
    cites: (state: any) => {
      // if (!!window["cities"]) {
      // return window["cities"];
      // }
      return state.cites;
    },
    areas: (state: any) => state.areas,
  },

  mutations: {
    SET_LIST_FETCHING(state: any, isFetchingList = false) {
      state.isFetchingList = isFetchingList;
    },

    SET_CITIES_LIST(state: any, cites) {
      state.cites = cites;
    },

    SET_AREAS_LIST(state: any, areas) {
      state.areas = areas;
    },
  },

  actions: {
    async getCities({ commit }: { commit: any }, country_code: string) {
      if (!!window["cities"]) {
        return;
      }
      return axios
        .get<Response<Array<CustomerAddressCity>>>(ENDPOINTS.ADDRESS.CITIES(country_code))
        .then(async ({ data }) => {
          window["cities"] = data?.data;
          commit("SET_CITIES_LIST", data?.data);
        })
        .catch(async (error) => {
          commit("SET_CITIES_LIST", []);
        });
    },

    /***
     * Handle to get the areas
     * @param commit
     * @param country_code
     * @param city_id
     */
    getAreasList: async function ({ commit }: { commit: any }, { country_code, city_id, queryParameters = "" }) {
      console.log(country_code, city_id);
      let filters = queryParameters ? `${queryParameters}` : "";
      await commit("SET_LIST_FETCHING", true);
      return await axios
        .get<Response<Array<AreaType>>>(ENDPOINTS.ADDRESS.AREAS(country_code, city_id, filters))
        .then((response) => response.data)
        .then(async ({ data }) => {
          console.log(data);
          const areaList: Array<AreaInterface> = data.map((area) => new Area(area)) || [];
          await commit("SET_AREAS_LIST", areaList);
        })
        .catch(async (error) => {
          await commit("SET_AREAS_LIST", []);
          await console.log(error);
        })
        .finally(async () => {
          await commit("SET_LIST_FETCHING", false);
        });
    },

    async getAvenues({ commit }: { commit: any }, payload) {
      return await axios
        .get<Response<Array<CustomerAddressAvenue>>>(ENDPOINTS.ADDRESS.AVENUES(payload))
        .then((response) => response.data)
        .then(async ({ data }) => {
          await console.log(data);
          debugger;
        })
        .catch(async (error) => {
          await console.log(error);
          debugger;
        });
    },
  },
};

export default Addresses;
